import { useEffect } from "react";
import { motion } from "framer-motion";
import retirementAssetsIllustration from "../../../static/illustration--retirement-assets.svg";
import CurrencyInput from "react-currency-input-field";
import { useAnswer } from "../../../util/form";

export default function AnnualSalary({
  advanceScreen,
  previousScreen,
  validation,
  updateValidation,
  value,
  screen,
}) {
  const { answer, setAnswer } = useAnswer(screen.id);

  useEffect(() => {
    console.log("value on mount/update:", value);
    // updateAnswer(true);
    // TODO: determine why other pages can use value.length here
    if (parseFloat(value) > 0) updateValidation(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateAnswer(value) {
    // Remove any non-numeric characters except decimal point
    let numericValue = value;
    if (typeof value === "string") {
      // Remove currency symbols, commas, etc.
      numericValue = value.replace(/[^0-9.]/g, "");
    }

    // Set to 0 if empty or null
    if (numericValue === "" || numericValue === null) {
      numericValue = 0;
    }

    // Ensure we're storing a numeric value
    const parsedValue = parseFloat(numericValue);

    // Save the value to the form state
    setAnswer(parsedValue);

    // Update validation
    updateValidation(parsedValue > 0);

    console.log("Saved annual salary:", parsedValue);
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <div className="px-6 py-16 text-center md:px-16 md:py-20">
        <div className="max-w-3xl mx-auto">
          <img
            className="block h-auto mx-auto w-28 md:w-36"
            src={retirementAssetsIllustration}
            alt=""
          />
          <h1 className="mt-6 mb-4 text-3xl md:mb-5 md:mt-8 md:text-4xl">
            What is your current annual salary?
          </h1>
          <div className="max-w-xl mx-auto">
            <p>
              We customize investment recommendations that fit your current
              salary, contributions, savings, and retirement goals.
            </p>
          </div>
        </div>
        <form className="mt-10 md:mt-14">
          <div className="max-w-md mx-auto">
            <h2 className="mb-4 text-xl font-light md:mb-6 md:text-2xl">
              My current annual salary is:
            </h2>
            <label
              className="block mb-1 text-sm font-bold text-left text-gray-800 sr-only"
              htmlFor="annualSalary"
            >
              Annual Salary
            </label>
            <div className="flex w-40 mx-auto mt-2 rounded shadow-sm">
              <span className="inline-flex items-center rounded-l border border-r-0 border-as-green-100 px-4 text-gray-600">
                $
              </span>
              <CurrencyInput
                id="annualSalary"
                name="annualSalary"
                required
                value={answer}
                aria-label="Annual Salary"
                className="w-full px-5 py-[1.125rem] mb-0 text-base text-gray-500 border-0 rounded-r ring-1 ring-inset ring-as-green-100 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-as-green-50"
                placeholder="0.00"
                onValueChange={(value) => {
                  updateAnswer(value);
                }}
                decimalsLimit="2"
                // prefix="$"
              />
              {/* <input
								type="text"
								id="annualSalary"
								name="annualSalary"
								
								value={answer}
								onChange={(e) => updateAnswer(e.target.value)}
								onKeyPress={ e => {
									const charCode = (e.which) ? e.which : e.keyCode;
									if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
										e.preventDefault();
									}
								} }
								aria-label="Annual Salary"
								className="w-full px-5 py-[1.125rem] mb-0 text-base text-gray-500 border-0 rounded-r ring-1 ring-inset ring-as-green-100 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-as-green-50"
							/> */}
            </div>
            <div className="flex justify-center gap-3 mt-10 md:mt-14 md:gap-5">
              <button type="button" className="btn btn--secondary" onClick={previousScreen}>
                Back
              </button>
              <button
                type="button"
                className="btn btn--primary"
                disabled={Boolean(validation) === false}
                onClick={advanceScreen}
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      </div>
    </motion.div>
  );
}
